

(function($, window) {


  let _slice = [].slice;
  let _toString = {}.toString;

  let PageHeader = (function() {

    function PageHeader() {
      this._init.apply(this, arguments);
    }

    PageHeader.dataName = 'PageHeader';
    PageHeader.defaultOptions = {

    };

    PageHeader.prototype = {
      constructor: PageHeader,

      _init: function($element, options) {
        this.$element = $element;
        this._options = options;

        this._setup();
      },

      _setup: function() {

        this._setEvents();
      },

      _setEvents: function() {

      },

      _removeEvents: function() {

      },

      show: function() {
        this.$element.addClass('is-shown');
      },

      hide: function() {
        this.$element.removeClass('is-shown');
      },

      destroy: function() {
        this._removeEvents();

        this.$element.removeData(PageHeader.dataName);
      }

    };

    return PageHeader;
  })();

  let methods = {

    init: function(options) {
      options = $.extend(true, {}, PageHeader.defaultOptions, options);

      this.each(function() {
        let $element = $(this);
        $element.data(PageHeader.dataName, new PageHeader($element, options));
      });
    },

    show: function() {
      this.each(function() {
        let instance = $(this).data(PageHeader.dataName);

        if(!instance) {
          return;
        }

        instance.show();
      });
    },

    hide: function() {
      this.each(function() {
        let instance = $(this).data(PageHeader.dataName);

        if(!instance) {
          return;
        }

        instance.hide();
      });
    },

    destroy: function() {

      this.each(function() {
        let instance = $(this).data(PageHeader.dataName);

        if(!instance) {
          return;
        }

        instance.destroy();
      });
    }
  };


  $.fn.pageHeader = function() {

    let args = _slice.call(arguments);

    let first = args[0];

    let rest = args.length > 1 ? _slice.call(arguments, 1) : [];

    if (!first) {
        methods.init.call(this);
    }

    else if($.isPlainObject(first)) {
        methods.init.apply(this, args);
    }

    else if(_toString.call(first) === '[object String]' && (first in methods)) {
        methods[first].apply(this, rest);
    }

    else {
        $.error('Failed to invoke a method or to initialise plugin.');
    }

    return this;
  };

})(jQuery, window);



// WEBPACK FOOTER //
// ./src/js/jquery-plugin/pageHeader.js